import React, {Component} from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faUser} from '@fortawesome/free-solid-svg-icons';
import './sub_card_principais.css';

export default class SubCardPrincipal extends Component {

    constructor(){
        super();
        this.state = {
            color: ''
        }

    }

    componentWillMount(){
        if(this.props.profissional.status){
            this.setState({color: '#00DA4A' })
        }else{
            this.setState({color: '##414141' })

        }


    }

    render(){
        return(
            <div className='col-md-4 sub-card-profissional forma-sombreada'>
                <div className='imagem-profissional'>
                    <a href={this.props.profissional.url}>
                        {/* <img  src={require(`../../imagens/profissionais/${this.props.profissional.img}`)}/> */}
                    </a>
                </div>
                <p>{this.props.profissional.nome}</p>
                <div className='profissional-icone-box'>
                    <FontAwesomeIcon icon={faUser} size='lg' color={this.state.color} className='icone-profissional'/>
                </div>
            </div>

        )
    }



}